import { Component, inject, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LikutProductBarcodeWithDefinition, LikutSubSQL } from '@interfaces/likut';
import { LikutScanService } from '@services/likut-scan.service';
import { LikutService } from '@services/likut.service';
import { Subject } from 'rxjs';
import { LikutTaskScanHistoryComponent } from '../likut-task-scan-history/likut-task-scan-history.component';

@Component({
	selector: 'app-likut-task-choose-scan-to-add',
	templateUrl: './likut-task-choose-scan-to-add.component.html',
	styleUrls: ['./likut-task-choose-scan-to-add.component.scss'],
})
export class LikutTaskChooseScanToAddComponent implements OnInit {
	_likut = inject(LikutService);
	_likutScan = inject(LikutScanService);
	private dialogRef = inject(MatDialogRef<LikutTaskScanHistoryComponent>);

	destroy$ = new Subject<void>();

	lines = this.data.definitionsWithLikutRows;
	code = this.data.barcodeScan;

	constructor(
		@Inject(MAT_DIALOG_DATA)
		private data: {
			definitionsWithLikutRows: {
				definition: LikutProductBarcodeWithDefinition;
				likutRow: LikutSubSQL;
			}[];
			barcodeScan: string;
		},
	) {}

	ngOnInit(): void {
		console.log(this.data);
		console.log('shut up');
	}

	onLineClick(line: typeof this.lines[number]) {
		this.dialogRef.close(line);
	}

	onCancelClick(): void {
		this.dialogRef.close();
	}
}
